import { CustomersRepository } from '@core/repositories/customers.repository';
import { Observable, of } from 'rxjs';

interface ResultCustomer {
  id: number;
  attributes: {
    customerName: string;
    documentTypeId: string;
    documentTypeName: string;
    documentNumber: string;
    monthlyValue: number;
    monthlyCount: number;
    annualValue: number;
    annualCount: number;
    creationDate: string;
    updateDate: string;
  };
}

interface ResultTypeIdentify {
  id: string;
  attributes: {
    name: string;
  };
}

export class FakeCustomersRepository implements CustomersRepository {
  dataCustomers: ResultCustomer = {
    id: 1,
    attributes: {
      creationDate: '2019-03-26 11:37:31.0',
      documentNumber: '1234567890',
      documentTypeId: 'FS001',
      documentTypeName: 'Cédula de ciudadania',
      customerName: 'Sandra Restrepo',
      updateDate: '2019-03-26 11:37:31.0',
      monthlyValue: 4000,
      monthlyCount: 20,
      annualValue: 6000,
      annualCount: 60
    }
  };

  dataTypeIdentify: Array<ResultTypeIdentify> = [
    {
      id: 'FS001',
      attributes: {
        name: 'Cédula de ciudadanía'
      }
    },
    {
      id: 'FS003',
      attributes: {
        name: 'NIT'
      }
    }
  ];

  customers = {
    data: [this.dataCustomers]
  };

  customer = {
    data: this.dataCustomers
  };

  typesIdentify = {
    data: this.dataTypeIdentify
  };

  getItems(): Observable<any> {
    // return throwError({status: 500, detail: 'Error'});

    return of(this.customers);
  }

  getItemId(typeIdentify: string, identify: string) {
    // return throwError({status: 500, detail: 'Error'});

    return of(this.customer);
  }

  getTypeIdentify(): Observable<any> {
    // return throwError({status: 500, detail: 'Error'});

    return of(this.typesIdentify);
  }
}
